import { ReactNode } from 'react';

import { CLOSET_VALUE, MIRROR_CABINETS_VALUE, MIRRORS_VALUE, PEDESTAL_VALUE } from '@shared/constants/catalog';
import { ID_SUBCATEGORY_ATTRIBUTE, ID_TYPE_PRODUCT_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';

import { Closet } from './Closet/Closet';
import { Mirrors } from './Mirrors/Mirrors';
import { MirrorsCabinet } from './MirrorsCabinet/MirrorsCabinet';
import { Pedestal } from './Pedestal/Pedestal';
import cls from './Chars.module.scss';

const COMPONENTS_BY_VALUE: Record<string, ReactNode> = {
  [PEDESTAL_VALUE]: <Pedestal />,
  [CLOSET_VALUE]: <Closet />,
  [MIRRORS_VALUE]: <Mirrors />,
  [MIRROR_CABINETS_VALUE]: <MirrorsCabinet />,
  'Led-зеркало': <Mirrors />
};

export const Chars = () => {
  const props = useAppSelector((state) => state.product.data.props);
  const category = props[ID_TYPE_PRODUCT_ATTRIBUTE]?.values?.[0]?.value;
  const subcategory = props[ID_SUBCATEGORY_ATTRIBUTE]?.values?.[0]?.value;

  const component =
    (subcategory && COMPONENTS_BY_VALUE[subcategory]) || (category && COMPONENTS_BY_VALUE[category]) || null;

  return <div className={cls.list}>{component}</div>;
};
